import {Injectable} from '@angular/core';
import {PaymentTransactionService} from "./payment-transaction.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {UserCardResponse} from "../interface/userCardResponse";
import {PaymentTransactionRequest} from "../models/paymentTransactionRequest";
import {PaymentTransactionResponse} from "../interface/paymentTransactionResponse";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {PaymentMethod} from "../enums/paymentMethod";
import {
  DUPLICATE_MONEY_LUX_UUID_MESSAGE,
  PAYMENT_LOAD_ERROR_MESSAGE
} from "../constants/global.constants";
import {FastshiftRequest} from "../models/fastshiftRequest";
import {FastshiftResponse} from "../models/fastshiftResponse";
import {MobileDetectionService} from "./mobile-detection.service";

@Injectable({
  providedIn: "root"
})
export class FastshiftService {

  constructor(
    private paymentTransaction: PaymentTransactionService,
    private snackBar: SnackBarUtil,
    private http: HttpClient,
  ) {
  }

  initPayment(price: string, product: string, validDays: string, userCard: UserCardResponse, isCommissionActive: boolean, moneyLuxUuid: string | null) {
    const userCardId: string = `${userCard.cardId}`;
    const paymentTransactionDescription: string = product;
    const paymentTransactionRequest: PaymentTransactionRequest = this.preparePaymentTransactionRequest(paymentTransactionDescription, userCard, userCardId, price, validDays, moneyLuxUuid);
    this.startFastshift(paymentTransactionRequest, isCommissionActive, paymentTransactionDescription, moneyLuxUuid);
  }

  initForProductBuying(amount: number, orderId: number) {
    const description: string = 'Product buying';
    const paymentTransactionRequest: PaymentTransactionRequest = new PaymentTransactionRequest(PaymentMethod.FASTSHIFT, description, null, null, amount, 1, null, 0, null, orderId);
    this.startFastshift(paymentTransactionRequest, false, description, null);
  }

  initFastShift(fastshiftRequest: FastshiftRequest): Observable<FastshiftResponse> {
    const url = `${environment.apiUrl}/fastshift`;
    return this.http.post<FastshiftResponse>(url, fastshiftRequest);
  }

  getStatusByNumber(orderNumber: string): Observable<PaymentTransactionResponse> {
    const url = `${environment.apiUrl}/fastshift/status`;
    const params = {
      orderNumber: orderNumber
    };
    return this.http.get<PaymentTransactionResponse>(url, { params });
  }

  private startFastshift(paymentTransactionRequest: PaymentTransactionRequest, isCommissionActive: boolean, description: string, moneyLuxUuid: string | null) {
    this.paymentTransaction.create(paymentTransactionRequest, isCommissionActive).subscribe({
      next: (response: PaymentTransactionResponse) => {
        const fastshiftReq: FastshiftRequest = {
          orderNumber: response.orderNumber,
          amount: response.amount,
          description: description,
          username: null,
          userSsn: null,
          checkEvocaAccount: false,
          accountGuid: null,
          externalOrderId: null,
          moneyLuxUuid: moneyLuxUuid
        };
        this.initFastShift(fastshiftReq).subscribe({
          next: (response: FastshiftResponse) => {
            this.processResponse(response);
          },
          error: (error: HttpErrorResponse) => {
            if (error.status === 409) {
              this.showSnackbar(MockupDataModel.error(PAYMENT_LOAD_ERROR_MESSAGE), SnackBarUtil.CLASSES.error);
            }
          }
        })

      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 511 && error.error && error.error.message) {
          this.showSnackbar(MockupDataModel.error(DUPLICATE_MONEY_LUX_UUID_MESSAGE), SnackBarUtil.CLASSES.error);
        }
      },
    });
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBar.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data,
    });
  }

  private processResponse(fastshiftResponse: FastshiftResponse) {
    const url = fastshiftResponse.data?.redirect_url;

    if (url) {
      window.open(url, '_blank');
    }
  }

  private preparePaymentTransactionRequest(paymentTransactionDescription: string, userCard: UserCardResponse, userCardId: string, price: string, validDays: string, moneyLuxUuid: string | null) {
    return new PaymentTransactionRequest(
      PaymentMethod.FASTSHIFT,
      paymentTransactionDescription,
      userCard.userId,
      userCardId,
      Number(price),
      Number(validDays),
      userCard.cardId,
      0,
      moneyLuxUuid
    );
  }

}
